import { connect } from 'react-redux'
import TrainingsTable from './trainings-table'
import { getTrainingsList } from '../../../../../stores/trainings/trainings.selectors'

const mapStateToProps = state => ({
  trainings: getTrainingsList(state)
})

export default connect(
  mapStateToProps,
  null
)(TrainingsTable)
